import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=0b1b2352&scoped=true"
import script from "./weight.vue?vue&type=script&lang=js"
export * from "./weight.vue?vue&type=script&lang=js"
import style0 from "./weight.vue?vue&type=style&index=0&id=0b1b2352&lang=css"
import style1 from "./weight.vue?vue&type=style&index=1&id=0b1b2352&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b2352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1b2352')) {
      api.createRecord('0b1b2352', component.options)
    } else {
      api.reload('0b1b2352', component.options)
    }
    module.hot.accept("./weight.vue?vue&type=template&id=0b1b2352&scoped=true", function () {
      api.rerender('0b1b2352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/components/weight.vue"
export default component.exports